module.exports = __webpack_public_path__ + "img/call_talent1.3f5531ca.jpeg";